import { Link } from 'gatsby';
import propType from 'prop-types';
import React from 'react';

const Tags = ({ tags }) => (
  <ul className="tags">
    <span className="tags__title">Topics:</span>
    {tags.map(({ name, uri }) => {
      return (
        <li className="tags__item" key={name}>
          <Link className="internal-link" to={uri}>
            {name}
          </Link>
        </li>
      );
    })}
  </ul>
);

Tags.propTypes = {
  tags: propType.arrayOf(
    propType.shape({
      name: propType.string.isRequired
    })
  ).isRequired
};

export default Tags;
